import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  Divider,
} from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';

const JobErrorDialog = ({ open, onClose, job }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" data-test-id="job-error-dialog">
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ErrorOutline color="error" />
            Job Failed
          </DialogTitle>
          <DialogContent dividers>
            {job && (
              <Box>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" color="text.secondary">Job ID</Typography>
                  <Typography variant="body2" sx={{ fontFamily: 'monospace' }}>{job.id}</Typography>
                </Box>
                
                {job.status && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary">Status</Typography>
                    <Typography variant="body2" color="error.main" sx={{ fontWeight: 'medium' }}>
                      {job.status.toUpperCase()}
                    </Typography>
                  </Box>
                )}

                {job.created_at && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary">Created</Typography>
                    <Typography variant="body2">
                      {new Date(job.created_at).toLocaleString()}
                    </Typography>
                  </Box>
                )}

                {job.completed_at && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle2" color="text.secondary">Failed At</Typography>
                    <Typography variant="body2">
                      {new Date(job.completed_at).toLocaleString()}
                    </Typography>
                  </Box>
                )}

                <Divider sx={{ my: 2 }} />

                {job.error_message && (
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
                      Error Message
                    </Typography>
                    <Alert severity="error" sx={{ mb: 2 }}>
                      <Typography 
                        variant="body2" 
                        sx={{ 
                          whiteSpace: 'pre-wrap',
                          wordBreak: 'break-word',
                        }}
                      >
                        {job.error_message}
                      </Typography>
                    </Alert>
                  </Box>
                )}

                {!job.error_message && (
                  <Alert severity="warning">
                    No error message available for this job.
                  </Alert>
                )}
              </Box>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={onClose} data-test-id="job-error-close-btn">Close</Button>
          </DialogActions>
        </Dialog>
    );
};

export default JobErrorDialog;
